import '@fortawesome/fontawesome-pro/js/brands';
import '@fortawesome/fontawesome-pro/js/solid';
import '@fortawesome/fontawesome-pro/js/fontawesome';

export default function initFontAwesome() {

}

